import { atom } from "jotai";
import { DropdownItem } from "../types";

export const a = 5;
export const layoutTypeAtom = atom<"grid" | "list">("grid");
export const organizationsDropdownItemsAtom = atom<DropdownItem[]>();
export const selectedOrgIdAtom = atom(0);
